module.exports = __webpack_public_path__ + "static/media/high-right-4.e3dda038.png";